import React, { useRef } from 'react';
import '../css/formats.css';
import { useReactToPrint } from "react-to-print";
import { Datos_Empresa, development } from "../libs/utils/Const";

export const FormatInvoiceModal = () => {

    const folio = "0000";
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Factura de reserva'+folio,
        onafterprint: () => alert('Print Success')
    })
    // const { newOrderModel } = this.props;
    return (
        
        <div>
            <div className="modal fade" id="formatInvoiceModal"  data-keyboard="false" tabIndex="-1" aria-labelledby="formatInvoiceModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content text-responsive">
                    <div className="modal-header">
                    </div> 
                    <div ref={componentRef} className="modal-body scrollPage" id="printInvoice">
                        <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                            <div className="row">
                                <div className="col-3">
                                    <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo"/>
                                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br/><strong>{Datos_Empresa.RFC}</strong></p>
                                    <span className="text-left">Teléfono(s):</span>
                                    <p>COL. C.P.;,.</p>
                                </div>
                                <div className="col-9">
                                    <table>
                                        <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                            <tr>
                                                <th className="text-center">Serie</th>
                                                <th className="text-center">Folio</th>
                                                <th className="text-center">Número de certificado:</th>
                                                <th className="text-center">Fecha - Hora emisión</th>
                                                <th className="text-center">Lugar de expedición</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                                <td className="text-center">fsdfsd</td>
                                                <td className="text-center">fsfs</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                            <tr>
                                                <th className="text-center">Folio Fiscal:</th>
                                                <th className="text-center">Certificado SAT:</th>
                                                <th className="text-center">Fecha y Hora de Certificacion:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                            <tr>
                                                <th className="text-center">No. Cliente:</th>
                                                <th className="text-center">Uso CFDI</th>
                                                <th className="text-center">Asesor de ventas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">dfsdf</td>
                                                <td className="text-center">fsdfsd</td>
                                                <td className="text-center">fsfs</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                            <tr>
                                                <th className="text-center">Tipo Factura</th>
                                                <th className="text-center">R.F.C.</th>
                                                <th className="text-center">Moneda</th>
                                                <th className="text-center">Folio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                                <td className="text-center">fsdfsd</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-5' style={{paddingRight:"15px"}}>
                                <table>
                                    <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                        <tr>
                                            <th className="text-center">DOMICILIO DE FACTURACIÓN</th>
                                            <th className="text-center" style={{width:"300px"}}>Forma y método de pago</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{borderLeft: "solid 1px"}}>
                                            <td className="text-center">fsf</td>
                                            <td className="text-center" style={{border: "solid 1px"}}>fsdf</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table>
                                    <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                        <tr>
                                            <th className="text-center">DOMICILIO DE ENTREGA</th>
                                            <th className="text-center" style={{width:"300px"}}>Fecha de vencimiento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{borderLeft: "solid 1px"}}>
                                            <td className="text-center">fsf</td>
                                            <td className="text-center" style={{border: "solid 1px"}}>fsdf</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table>
                                    <thead>
                                        <tr style={{borderLeft: "solid 1px"}}>
                                            <th className="text-center" ></th>
                                            <th className="text-center" style={{width:"300px", background: Datos_Empresa.BackgroundColor, color:"white"}}>Nombre del capturista</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{borderLeft: "solid 1px", borderBottom: "solid 1px"}}>
                                            <td className="text-center"></td>
                                            <td className="text-center" style={{border: "solid 1px"}}>fsdf</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className='mt-5'>
                                    <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                        <tr>
                                            <th>Cant.</th>
                                            <th>UMV</th>
                                            <th>CVE</th>
                                            <th>Cve P/S</th>
                                            <th className="text-center">Código</th>
                                            <th className="text-center">Descripción</th>
                                            <th className="text-right">Tasa</th>
                                            <th className="text-right">Precio U</th>
                                            <th className="text-right">Importe</th>
                                            <th className="text-right">Descuento</th>
                                            <th className="text-right">Importe N.</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{border: "solid 1px"}}>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                        <tr>
                                            <td>fsf</td>
                                            <td>fsdf</td>
                                            <td>dfsdf</td>
                                            <td>fsdfsd</td>
                                            <td className="text-center">fsfs</td>
                                            <td className="text-center">fsf</td>
                                            <td className="text-right">fsdf</td>
                                            <td className="text-right">dfsdf</td>
                                            <td className="text-right">fsdfsd</td>
                                            <td className="text-right">fsfs</td>
                                            <td className="text-right">fsfs</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='row mt-3' style={{paddingRight:"15px"}}>                                    
                                <table>                                            
                                    <tbody>
                                        <tr>
                                            <td className='text-left' rowSpan={5}>
                                                <p>
                                                    Comentarios:<br/>
                                                    TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.<br/>
                                                    NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES.<br/>
                                                    EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICION.<br/>
                                                    Régimen General de Ley Personas Morales.<br/>
                                                </p>
                                            </td>
                                            <td className='text-right'><strong>Subtotal: </strong></td>
                                            <td className='text-right' style={{borderLeft: "solid 1px",borderRight: "solid 1px", borderTop: "solid 1px", minWidth:"6.25vw"}}>fsdf</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>Descuento: </strong></td>
                                            <td className='text-right' style={{borderLeft: "solid 1px",borderRight: "solid 1px"}}>fsdf</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>IVA: ? % </strong></td>
                                            <td className='text-right' style={{borderLeft: "solid 1px",borderRight: "solid 1px"}}>fsdf</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>Retención: </strong></td>
                                            <td className='text-right' style={{borderLeft: "solid 1px",borderRight: "solid 1px"}}>fsdf</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>Total: </strong></td>
                                            <td className='text-right' style={{borderLeft: "solid 1px",borderRight: "solid 1px", borderBottom: "solid 1px"}}>fsdf</td>
                                        </tr>
                                    </tbody>
                                </table>                                    
                            </div>
                            <div className='row mt-5' style={{paddingRight:"15px"}}>
                                <div className='col-12' style={{border: "solid 1px"}}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="text-center"></th>
                                                <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                                                <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><strong>Sello digital autorizado:</strong></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                            <tr>
                                                <td><strong>Sello digital SAT:</strong></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                            <tr>
                                                <td><strong>Cadena original:</strong></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-2' style={{paddingRight:"15px"}}>
                                <div className='col-12' style={{border: "solid 1px"}}>
                                    <p>
                                        Pagaré No. - ? En, a . Bueno por <br/>
                                        Debo(emos) y pagaré(mos) incondicionalmente por este pagaré a la orden de {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad},<br/>
                                        , . Fecha pago: <br/>
                                    </p>
                                    <p>
                                        La cantidad de:
                                        Valor recibido a mi(nuestra) entera satisfacción, este pagaré sujeto a la condición de que al no pagarse a su vencimiento será exigible, desde la fecha de su vencimiento de este 
                                        documento hasta el día de su liquidación, causará intereses moratorios al tipo de 3% mensual, pagadero en esta ciudad justamente con el principal.
                                    </p>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="text-center"></th>
                                                <th className="text-left"><strong>Nombre y datos del deudor:</strong></th>
                                                <th className="text-center">Aceptamos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-right">Nombre:</td>
                                                <td className="text-left"></td>
                                                <td className="text-center"></td>
                                            </tr>
                                            <tr>
                                                <td className="text-right">RUT:</td>
                                                <td className="text-left"></td>
                                                <td className="text-center">______________________________</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className="text-left"></td>
                                                <td className="text-center">Firma</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">Dirección: C.P.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-5' style={{paddingRight:"15px"}}>
                                <div className='col-2'style={{border: "solid 1px"}}>
                                    <p className='text-center m-4' style={{margin:"auto"}}>
                                        <strong>REFERENCIAS<br/>PARA<br/>DEPÓSITO<br/>BANCARIO</strong>
                                    </p>
                                </div>
                                <div className='col-10 p-2' style={{border: "solid 1px"}}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Para transferencias:</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Para transferencias:</td>
                                                <td>Cuenta: 00000515541</td>
                                                <td>CLABE: 113180000005155411</td>
                                                <td>Referencia:</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Para depósitos en ventanilla:</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Banco: Santander</td>
                                                <td>Cuenta: 65506444181</td>
                                                <td>CLABE: 014730655064441811</td>
                                                <td>Referencia:</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Banco: HSBC</td>
                                                <td>Cuenta: 4062752217</td>
                                                <td>CLABE: 021730040627522173</td>
                                                <td>Referencia:</td>
                                                <td></td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>                           
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handlePrint}>Imprimir</button>
                        
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormatInvoiceModal;